<template>
  <div class="ticket-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        size="small"
        class="query-middle"
      >
        <el-form-item label="游客名称" prop="Name">
          <el-input v-model="query.Name"></el-input>
        </el-form-item>
         <el-form-item label="创建时间："  style="margin-left:20px;">
          <el-date-picker
            v-model="query.StartTime"
            type="date"
            style="width: 200px"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="—">
          <el-date-picker
            v-model="query.EndTime"
            type="date"
            style="width: 200px"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="创建时间" prop="StartTime">
          <el-date-picker
            v-model="query.StartTime"
            type="date"
            style="width: 160px"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item style="margin-left:20px;">
          <el-button type="primary" icon="el-icon-search" @click="getVisitors"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            icon="el-icon-circle-close"
            @click="resetForm('queryForm')"
            >清除</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i> 游客列表 </span>
        </div>
        <div class="left-table">
          <el-table :data="tableData" height="753px" border style="width: 100%">
            <!-- @selection-change="handleSelectionChange" -->
            <el-table-column
              type="selection"
              min-width="10"
              align="center"
            ></el-table-column>
            <el-table-column
              label="姓名"
              prop="Name"
              min-width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="创建时间"
              prop="JoinTime"
              min-width="160"
              align="center"
            >
              <template slot-scope="scope">{{
                scope.row.JoinTime | dateFormat
              }}</template>
            </el-table-column>
            <el-table-column
              label="联系方式"
              prop="Tel"
              min-width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              label="身份证"
              prop="IDNumber"
              min-width="170"
              align="center"
            ></el-table-column>
            <el-table-column
              label="状态"
              prop="Status"
              min-width="80"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Status | keyToVal(statusType)"
                  effect="dark"
                  size="small"
                  >{{ scope.row.Status | keyToVal(normalStatus) }}</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              min-width="140"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="center">
                  <el-button
                    size="mini"
                    type="primary"
                    v-on:click="getDetail(scope.row)"
                    >查看</el-button
                  >
                  <!-- <el-popconfirm
                    title="确认删除吗？"
                    v-if="scope.row.main==false"
                    v-on:onConfirm="deleteVisitor(scope.row)"
                  >
                    <el-button size="mini" type="danger" slot="reference"
                      >删除</el-button
                    >
                  </el-popconfirm> -->
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="pagination.total"
            :page-size="pagination.PageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="pagination.PageIndex"
            v-on:size-change="handlePageSize"
            v-on:current-change="handlePageIndex"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span> <i class="el-icon-document"></i> 游客信息 </span>
          <el-button
            type="success"
            size="mini"
            @click="model.visible = true"
            v-show="flag == 1"
          >
            <i class="el-icon-document"></i>编辑
          </el-button>
        </div>
        <table class="input-form" v-show="flag == 1">
          <thead>
            <th colspan="6" class="emphasis">游客订单</th>
          </thead>
          <tbody>
            <tr style="height: 41px">
              <td style="min-width: 120px">游玩线路</td>
              <td colspan="2" class="emphasis">{{ detail.LineName }}</td>
              <td style="min-width: 120px">游玩时间</td>
              <td colspan="2" class="emphasis">
                {{ detail.PlayTime + " 至 " + detail.EndTime }}
              </td>
            </tr>
            <tr style="height: 41px">
              <td style="min-width: 120px">同行人数</td>
              <td style="min-width: 40px" class="emphasis">
                {{ detail.TotoalCount }}
              </td>
              <td style="min-width: 120px">老年人票（人）</td>
              <td class="emphasis" style="min-width: 40px">
                {{ detail.ElderlyCount }}
              </td>
              <td style="min-width: 120px">儿童票（人）</td>
              <td class="emphasis">{{ detail.ChildrenCount }}</td>
            </tr>
            <tr>
              <td colspan="6" class="emphasis">行程安排</td>
            </tr>
            <tr style="height: 45px">
              <td colspan="6"></td>
            </tr>
            <div class="subtable-tab">
              <div
                v-for="(item, index) in table"
                :key="index"
                class="mouse-pointer tab-item"
                :class="{ 'sub-selected': currentSubId === item.id }"
                @click="switchSubtable(item.id)"
              >
                <div>第{{ item.id + 1 }}天</div>
              </div>
            </div>
            <tr>
              <td colspan="2">行程项目</td>
              <td colspan="2">行程时间</td>
              <td colspan="2">行程类型</td>
            </tr>
            <tr
              v-for="item in table[currentSubId].arrangement"
              :key="item.proId"
            >
              <td colspan="2">{{ item.Projects }}</td>
              <td colspan="2">
                {{ item.StartTime | getProjectTime(item.EndTime) }}
              </td>
              <td colspan="2">
                {{ item.PointId | getProjectType(options.projects) }}
              </td>
            </tr>
            <tr>
              <td :rowspan="detail.newListTourist.length + 1" class="emphasis">
                游客信息
              </td>
              <td>游客姓名</td>
              <td>手机号</td>
              <td>证件类型</td>
              <td>身份证</td>
              <td>团队负责人</td>
            </tr>
            <tr v-for="(item, index) in detail.newListTourist" :key="index + 1">
              <td>{{ item.Name }}</td>
              <td>{{ item.Tel }}</td>
              <td>{{item.CertificatesType}}</td>
              <td>{{ item.IDNumber }}</td>
              <td>{{ item.IsMain == false ? "否" : "是" }}</td>
            </tr>
          </tbody>
        </table>
        <el-row align="center" v-show="flag == 1">
          <el-button
            @click="contractDialog = true"
            type="success"
            style="margin-top: 30px; margin-left:20px; margin-bottom:30px;"
            >查看合同</el-button
          >
        </el-row>
      </div>

      <!-- 合同 -->
      <el-dialog :visible.sync="contractDialog" >
        <contract-detail
          :orderId="detail.orderId"
          v-if="contractDialog"
        ></contract-detail>
         <div class="btn">
        <el-button @click="contractDialog = false"
          ><a style="color: #000">取 消</a></el-button
        >
        <el-button v-if="contractInfo.ContactAttachment" 
          ><a
            :href="
              '/api/co/Order/DownLoadOneDayContact?orderId=' +
              contractInfo.orderId +
              '&sessionId=' +
              sessionId
            "
            style="color: #000"
            >下载合同</a
          ></el-button
        >
      </div>
      </el-dialog>
    </div>

    <!-- 编辑模态框 -->
    <el-dialog
      @closed="resetForm('updateForm')"
      title="修改游客信息"
      :visible.sync="model.visible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form
        ref="updateForm"
        :model="model.form"
        :rules="model.rules"
        label-width="120px"
      >
        <el-form-item label="姓名" prop="Name">
          <el-input v-model="model.form.Name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="Tel">
          <el-input v-model="model.form.Tel"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="CertificatesType">
          <el-select v-model="model.form.CertificatesType" placeholder="请选择证件类型">
            <el-option
              v-for="item in optionsType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号" prop="IDNumber">
          <el-input v-model="model.form.IDNumber"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="model.visible = false">取 消</el-button>
        <el-button type="primary" @click="postModel('updateForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getToken, getCookie } from "@/common/auth";
import { keyToVal, dateFormat } from "@/filters/filters";
import { validatePhone, validateIdNo } from "@/common/element-validator";
import Order from "@/api/order";
import { mapState } from "vuex";
import ContractDetail from "@/components/Contract.vue";

export default {
  name: "VisitorManage",
  data() {
    return {
      optionsType:[{
          value: '身份证',
          label: '身份证'
        }, {
          value: '港澳通行证',
          label: '港澳通行证'
        }, {
          value: '台湾通行证',
          label: '台湾通行证'
        },{
          value: '护照',
          label: '护照'
      }],

      contractInfo: {},
      sessionId: "",

      query: {
        Name: "",
        StartTime: "",
        EndTime: "",
      },
      contractDialog: false,
      flag: 0,
      detail: {
        orderId: "", //订单Id
        LineId: "", //线路Id
        LineName: "",
        PlayTime: "", //游玩时间
        EndTime: "", //结束时间
        TotoalCount: 0, //总人数
        ElderlyCount: "", //老年人数
        ChildrenCount: "", //儿童人数
        //游客信息表
        newListTourist: [{ Name: "", Tel: "", IDNumber: "",CertificatesType:"" }],
      },
      model: {
        form: {
          Id:"",
          Name: "",
          Tel: "",
          IDNumber: "",
          CertificatesType:"",
        },
        rules: {
          Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          // Tel: [{ required: true, validator: validatePhone, trigger: "blur" }],
          IDNumber: [
            { required: true, message: "请输入游客证件", trigger: "blur" },
          ],
        },
        visible: false,
      },
      tableData: [], 
      pagination: {
        total: 0,
        PageSize: 10,
        PageIndex: 1,
      },
      currentSubId: 0,
      table: [
        {
          id: 0,
          arrangement: [],
        },
      ],
    };
  },
  components: { ContractDetail },
  filters: {
    keyToVal,
    dateFormat,
    getProjectType(value, projects) {
      for (const pro of projects) {
        if (pro.Id == value) {
          return pro.Type;
        }
      }
      return "";
    },
    getProjectTime(start, end) {
      let startTime = +start,
        endTime = +end;
      if (isNaN(startTime) || isNaN(endTime)) return "";
      return `${parseInt(startTime / 60)}:${(startTime % 60)
        .toString()
        .padStart(2, "0")} 
      至 ${parseInt(endTime / 60)}:${(endTime % 60)
        .toString()
        .padStart(2, "0")}`;
    },
  },
  inject: ["deepClone"],
  computed: {
    ...mapState("trip", {
      options: (state) => {
        return {
          routes: state.routes,
          projects: state.projects,
        };
      },
    }),
    ...mapState("common", ["normalStatus", "statusType"]),
  },
  methods: {
    GetData(orderId) {
      var _self = this;
      Order.getContractData({ Id: orderId }).then((res) => {
        if (res.status === "success") {
          _self.contractInfo = res.content;
        } else {
          _self.$message.error("合同获取失败!");
        }
      });
    },
    //获取游客列表
    getVisitors() {
      this.query.PageSize = this.pagination.PageSize;
      this.query.PageIndex = this.pagination.PageIndex;
      Order.listVistors(this.query).then((res) => {
        if (res.status === "success") {
          this.pagination.total = res.content.Total;
          this.tableData = res.content.OnePageData;
        } else {
          this.$message.error("列表获取失败");
        }
      });
    },
    resetForm(formName) {
      if (formName === "queryForm") {
        this.query = {
          Name: "",
          StartTime: "",
          EndTime: "",
          PageSize: 10,
          PageIndex: 1,
        };
        this.getVisitors();
      }
    },
    exportTable() {},
    getDetail(row) {
      var _self=this;
      _self.model.form.Name=row.Name;
      _self.model.form.Tel=row.TelTemp;
      _self.model.form.IDNumber=row.IDNumberTemp;
      _self.model.form.CertificatesType=row.CertificatesType;
      _self.model.form.Id=row.Id;
      // _self.model.form = _self.deepClone(row);
      Order.visitorDetail({ Id: row.Id }).then((res) => {
        if (res.status === "success") {
          _self.detail.orderId = res.content.orderId;
          _self.GetData(_self.detail.orderId);
          _self.detail.LineId = res.content.lineId;
          _self.detail.LineName = res.content.lineName;

          // _self.detail.PlayTime = dateFormat(res.content.PlayTime);
          // _self.detail.EndTime = dateFormat(
          //   new Date(res.content.PlayTime).getTime() +
          //     res.content.dayCount * 60 * 60 * 24 * 1000
          // );

          _self.detail.TotoalCount = res.content.TotoalCount;
          _self.detail.ChildrenCount = res.content.ChildrenCount;
          _self.detail.ElderlyCount = res.content.ElderlyCount;
          if (res.content.dataTourist !== null) {
            //设置游客
            _self.detail.newListTourist = res.content.dataTourist.map((v) => {
              return {
                Id: v.Id,
                Name: v.Name,
                Tel: v.Tel,
                IDNumber: v.IDNumber,
                CertificatesType:v.CertificatesType,
                IsMain: v.Id == res.content.mainId,
              };
            });
          }
          //设置行程项目
          if (Array.isArray(res.content.lineDetails)) {
            _self.table = res.content.lineDetails.map((v, i) => {
              return {
                id: i,
                arrangement: [...v.dataList],
              };
            });

            var times = res.content.lineDetails.map((v, i) => {
              return {
                id: i,
                arrangement: [
                  ...v.dataList.map((pro) => {
                    return {
                      Id: pro.PointId,
                      Name: pro.Projects,
                      Time: [
                        `${parseInt(pro.StartTime / 60)}:${(pro.StartTime % 60).toString().padStart(2, '0')}`,
                        `${parseInt(pro.EndTime / 60)}:${(pro.EndTime % 60).toString().padStart(2, '0')}`,
                      ],
                    }
                  }),
                ],
              }
            })

            if (times != null && times.length > 0 && times != '') {
              //第一天的开始时间
              var start = times[0].arrangement[0].Time[0]; 
              //最后一天的结束时间
              var end =times[times.length - 1].arrangement[times[times.length - 1].arrangement.length - 1].Time[1];

              var aa= _self.formatDate(new Date(res.content.PlayTime).getTime());
              _self.detail.PlayTime = aa+' '+start;

              var bb = new Date(res.content.PlayTime).getTime() + (res.content.dayCount - 1) * 60 * 60 * 24 * 1000;
              _self.detail.EndTime = _self.formatDate(bb) + ' ' + end;
            }
          }
          _self.flag = 1;
        } else {
          _self.$message.error("信息获取失败!");
        }
      });
    },
    //日期时间格式转换
    formatDate(time) {
      let date = new Date(time)
      let Y = date.getFullYear() + '-'
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D
    },
    deleteVisitor(row) {
      var _self=this;
      Order.deleteVisitor({ Id: row.Id }).then((res) => {
        if (res.status === "success") {
          _self.$message.success("删除成功!");
          _self.getVisitors();
        } else {
          _self.$message.error(res.msg);
        }
      });
    },
    postModel(formName) {
      var _self=this;
      _self.$refs[formName].validate((success) => {
        if (success) {
          Order.updateVisitor(_self.model.form).then((res) => {
            if (res.status === "success") {
              _self.$message.success("修改成功!");
              _self.getVisitors();
              _self.model.visible = false;
            } else {
              _self.$message.error(res.msg);
            }
          });
        } else {
          _self.$message.error("信息格式错误!");
        }
      });
    },
    handlePageSize(value) {
      this.pagination.PageSize = value;
    },
    handlePageIndex(value) {
      this.pagination.PageIndex = value;
      // this.getVisitors();
    },
  },
  created() {
    this.getVisitors();
  },
  watch: {
    "pagination.PageSize": function () {
     this.getVisitors();
    },
    "pagination.PageIndex": function () {
      this.getVisitors();
    },
  },
   mounted() {
    this.sessionId = getCookie("sessionId");
  },
};
</script>

<style scoped lang="less">
.main-left {
  width: 40%;
  min-width: 620px;
  border-right: 1px solid #ddd;
}
.main-left .left-table {
  height: 753px;
  background: chocolate;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 4%;
  left: 55%;
  transform: translate(-50%);
}
.pagination-bottom{
   position: relative;
  left: 65%;
  transform: translate(-50%);
}
.main-right {
  flex: 1;
}
.right-table {
  padding: 20px;
  min-width: 800px;
}
.input-form {
  margin-top: 20px;
  margin-left: 20px;
  position: relative;

  width: 96%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.sub-selected {
  background: cornflowerblue;
}
.subtable-tab {
  position: absolute;
  top: 148px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
}
.subtable-tab .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.emphasis {
  font-weight: bolder;
}
.input-form /deep/ .el-select {
  width: 100%;
}

.input-form /deep/ .el-input__inner {
  border: none;
  width: 100%;
}
</style>
